<div class="container container--mobile-padding">
	<ng-container *ngIf="ifLoading">
		<div class="no-result-margin">{{"LOADING" | translate }}</div>
	</ng-container>

	<ng-container *ngIf="!ifLoading">
		<ng-container *ngIf="searchResult && searchResult.length">
			<two-column-tile [dataItems]="searchResult"></two-column-tile>
		</ng-container>

		<ng-container *ngIf="searchResult && searchResult.length==0">
			<div class="no-result-margin">{{"SEARCH.NO_RESULTS" | translate }}</div>
		</ng-container>

		<ng-container *ngIf="!searchQuery">
			<div class="no-result-margin">{{"SEARCH.EMPTY" | translate }}</div>
		</ng-container>
	</ng-container>
</div>
